module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/about-collection-a877999b016135fd56ee609fdcf296b1.png";